import { WorkshiftModelAPI, WorkshiftTypeModelAPI } from '../../../../models';
import { WorkshiftLongWorkshift } from '../../../../models/workshifts/workshiftLongWorkshifts';
import { getAllWorkshiftsTypesAdapter, getWorkshiftAdapter } from '../../Adapters';
import { requests } from '../apiAgent';

export const WorkshiftsAPI = {
    getAllTypes: () => {
        return requests
            .get('/jerusalem/api/v2.0.0/workshifts')
            .then((response: WorkshiftTypeModelAPI[]) =>
                getAllWorkshiftsTypesAdapter(response)
            );
    },
    getLongTypes: (compensationDate: string) => {
        return requests
            .post('/jerusalem/api/v2.0.0/workshifts/long-workshifts', {
                requestDate: compensationDate,
            })
            .then((response: WorkshiftLongWorkshift[]) => response);
    },
    getAllWorkshiftsList: () => {
        return requests
            .get(
                '/jerusalem/api/v2.0.0/scheduling-change-requests/get-all-workshift'
            )
            .then((response: WorkshiftTypeModelAPI[]) =>
                getAllWorkshiftsTypesAdapter(response)
            );
    },
    get: (workshitId: number) => {
        return requests
            .get('/jerusalem/api/v2.0.0/workshifts/' + workshitId)
            .then((response: WorkshiftModelAPI) => getWorkshiftAdapter(response));
    },
};
